import { Helmet } from 'react-helmet-async';

const faqs = [
  {
    q: "How can you be sure the videos will work for me?",
    a: "We're specialized 100% in high-performing video ads. Our team writes every script, directs every shoot in-house, and produces ads every week — we know exactly how to structure creative that converts.",
  },
  {
    q: "What's the difference between you and another agency?",
    a: "Compared to a big agency: we're 3 to 4x cheaper and deliver 2 to 3x more results per video. Compared to UGC creators: we don't outsource shoots, so you're never dependent on a single creator, and we offer multiple formats (indoor, outdoor, studio, on-location). Compared to a beginner agency: we've served 65+ businesses and built our expertise on real client results.",
  },
  {
    q: "Does the 10-video pack fit my industry?",
    a: "We've produced ads for construction, real estate, restaurants, tobacco retail, law firms, churches, and more. Whatever your industry, we adapt the format — iPhone-style ads, professional studio setups, on-site interviews — to fit your audience and objectives.",
  },
  {
    q: "How long does it take to receive the finalized videos?",
    a: "You receive the V1 of your videos within 10 days after the video shoot. Before that, we handle concept ideation, script writing and actor/talent activation — then it's full editing with unlimited revisions until you're happy.",
  },
  {
    q: "Do you have proof or guarantees of your results?",
    a: "Yes — check our case studies page for detailed breakdowns. On top of that, we work with zero commitment, which means we're forced to deliver real results if we want you to keep working with us.",
  },
  {
    q: "How does the collaboration work?",
    a: "First, we send you a form to gather everything about your brand and product. Once payment is received, we pitch concepts within 2-3 days. You pick your favorites and we write scripts within 3-4 days. Once validated, we cast actors and organize the shoot. You receive the V1 of your videos within 10 days after the shoot, with unlimited revisions.",
  },
  {
    q: "What's included in artistic direction?",
    a: "Everything creative: mood, tone, visual style, framing, lighting choices, actor casting, wardrobe, on-set direction, editing style, music, and pacing. You get a fully directed shoot, not just a camera crew showing up.",
  },
];

export const HomeFaq = () => (
  <section className="section section-dark" id="faq" aria-labelledby="faq-heading">
    <Helmet>
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(f => ({
          "@type": "Question",
          "name": f.q,
          "acceptedAnswer": { "@type": "Answer", "text": f.a },
        })),
      })}</script>
    </Helmet>
    <div className="container mx-auto max-w-4xl px-4">
      <h2 id="faq-heading" className="text-3xl md:text-4xl font-bold mb-10 text-center">
        Frequently Asked Questions
      </h2>
      <div className="space-y-4">
        {faqs.map((f, i) => (
          <details key={i} className="glass-card group">
            <summary className="cursor-pointer text-lg font-semibold list-none flex justify-between items-center">
              <span>{f.q}</span>
              <span className="text-primary ml-4 group-open:rotate-45 transition-transform">+</span>
            </summary>
            <p className="mt-4 text-muted-foreground leading-relaxed">{f.a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
